/* eslint-disable eslint-comments/disable-enable-pair -- need flat button */
/* eslint-disable @typescript-eslint/no-deprecated -- need flat button */
import type { ButtonHandle } from "@tql/ui-components-react/kendo/buttons";
import { Button as KendoButton } from "@tql/ui-components-react/kendo/buttons";
import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Popup } from "@tql/ui-components-react/kendo/popup";
import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	dotsVerticalLine,
	file_06,
} from "@tql/ui-components-react/untitled/icons";
import { useCallback, useRef, useState } from "react";
import { useParams } from "react-router";

import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

import { ErrorModal } from "../components/error-modal/index.tsx";
import { ShipmentDetails } from "../components/shipment-details/shipment-details.tsx";
import { ShipmentProgress } from "../components/shipment-progress/shipment-progress.tsx";
import { TrackingHistory } from "../components/tracking-history/tracking-history.tsx";
import type { AugmentedShipment } from "../types/augmented-shipment";

export const ExternalShipmentManagement = ({
	shipment,
	handleDocumentClick,
	onOpenNotifications,
	error,
}: {
	shipment: AugmentedShipment;
	handleDocumentClick: () => void;
	onOpenNotifications?: () => void;
	error: Error | null;
}) => {
	const { isEnabled: notificationsEnabled } = useFeatureFlagGate(
		"traxLtlNotifications",
	);
	const actionsAnchor = useRef<ButtonHandle | null>(null);
	const [showActionsMenu, setShowActionsMenu] = useState(false);

	const handleCloseActionsMenu = useCallback(() => {
		setShowActionsMenu(false);
	}, []);

	const handleSubscribeClick = useCallback(() => {
		onOpenNotifications?.();
		handleCloseActionsMenu();
	}, [onOpenNotifications, handleCloseActionsMenu]);
	const params = useParams();
	return (
		<div className={"container"}>
			<ErrorModal error={error} show={!!error} />

			<div className={"flex-header"}>
				<h4 data-testid={"shipment-management-heading"}>
					{error
						? ""
						: shipment?.customer?.customerName + " - " + params["poNumber"]}
				</h4>
				<div className={"header-actions"}></div>
				<Button
					aria-label={"View shipment documents"}
					data-testid={"document-trigger"}
					onClick={handleDocumentClick}
					variant={"tertiary"}
				>
					<SvgIcon icon={file_06} size={"xxlarge"} />
				</Button>
				{notificationsEnabled && onOpenNotifications ? (
					<>
						<KendoButton
							ref={actionsAnchor}
							data-testid={"notifications-actions-trigger"}
							disabled={showActionsMenu}
							fillMode={"flat"}
							onClick={() => setShowActionsMenu(true)}
							svgIcon={dotsVerticalLine}
						/>
						<Popup
							anchor={
								actionsAnchor.current ? actionsAnchor.current.element : null
							}
							anchorAlign={{ horizontal: "right", vertical: "bottom" }}
							onMouseDownOutside={handleCloseActionsMenu}
							popupAlign={{ horizontal: "right", vertical: "top" }}
							show={showActionsMenu}
						>
							<div style={{ display: "flex", flexDirection: "column" }}>
								<KendoButton fillMode={"flat"} onClick={handleSubscribeClick}>
									Subscribe to Notifications
								</KendoButton>
							</div>
						</Popup>
					</>
				) : null}
			</div>

			<div className={"shipment-management-grid"}>
				<div className={"left-column"}>
					<ShipmentProgress
						details={shipment?.shipmentProgress}
						shipment={shipment}
					/>
					<TrackingHistory
						carrierWebsite={shipment?.carrier?.carrierWebsite}
						details={shipment?.groupedCheckCalls ?? {}}
					/>
				</div>
				<div className={"right-column"}>
					<ShipmentDetails shipment={shipment} />
				</div>
			</div>
		</div>
	);
};
